import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from 'react';
import { cn } from '@morpho-org/ui-v6/utils';

/**
 * The subset of ui-v5 (legacy kit) `Color` tokens passed to the vault title. The value
 * comes from `getWarningsColor` (warning levels) or the `text.tertiary`
 * fallback used for the trailing part of the vault name.
 */
type VaultTitleColor = 'text.interactive.error' | 'text.interactive.warning' | 'text.tertiary';
const colorClasses: Record<VaultTitleColor, string> = {
  'text.interactive.error': 'text-destructive-foreground',
  'text.interactive.warning': 'text-warning-foreground',
  'text.tertiary': 'text-muted-foreground'
};
interface ResponsiveVaultTitleProps extends PropsWithChildren {
  color?: VaultTitleColor;
}

/**
 * Vault hero title: `text-title-lg` (60px) shrinking to `text-title-md` (48px)
 * below the `sm` breakpoint (640px), with `word-break: break-all` and an
 * optional color override. Defaults to the typo class' `text-primary` color.
 */
export const ResponsiveVaultTitle = t0 => {
  const $ = _c(5);
  const {
    color,
    children
  } = t0;
  const t1 = color && colorClasses[color];
  let t2;
  if ($[0] !== t1) {
    t2 = cn("text-title-lg max-sm:text-title-md break-all", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== t2) {
    t3 = <span className={t2}>{children}</span>;
    $[2] = children;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};